import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button,
  Checkbox
} from 'semantic-ui-react'

const CardNursingDiagnosisUX = (props: any) => {
    return(
      <div
        id="CardNursingDiagnosisUX-div-0"
        style={{width: "100%", height: "100%"}}>
        <div
          id="CardNursingDiagnosisUX-div-3"
          style={{display: "flex",alignItems: "center",justifyContent: "flex-end", ...(props.isPHV && { display: "none" })}}>
          
          <div
            id="CardNursingDiagnosisUX-div-49">
            {props.nursingDiagnosisID}
          </div>
          <div
            id="CardNursingDiagnosisUX-div-50">
            {props.searchButton}
          </div>
          <Button
            color="blue"
            id="CardNursingDiagnosisUX-Button-43"
            onClick={props.onTemplate}
            size="small"
            style={{marginLeft: "5px"}}>
            {props.languageUX === "en" ? "Select Template" : "เลือก Template"}
          </Button>
        </div>
        <div
          style={{ display: "flex",alignItems: "center",justifyContent: "flex-end", ...(!props.isPHV && { display: "none" }) }}>
          
          <Checkbox
            checked={props.checked}
            label={props.languageUX === "en" ? "Select all" : "เลือกทั้งหมด"}
            onChange={props.onChangeChecked}
            style={{padding: "10px"}}>
          </Checkbox>
          <div>
            {props.buttonPrint}
          </div>
        </div>
        <Table
          className="--rt-tbody-overflow-y-hidden"
          columns={props.columns_nursingDiagnosisList}
          data={props.nursingDiagnosisList}
          id="CardNursingDiagnosisUX-Table-23"
          minRows={10}
          showPagination={false}
          style={{height: "400px", marginBottom: "10px"}}>
        </Table>
        <div
          id="CardNursingDiagnosisUX-div-33"
          style={{display: "flex", alignItems: "center", justifyContent: "space-between", ...(props.isPHV && { display: "none" })}}>
          
          <div
            id="CardNursingDiagnosisUX-div-45">
            {props.addButton}
          </div>
          <div
            id="CardNursingDiagnosisUX-div-46"
            style={{display: "flex"}}>
            
            <Checkbox
              checked={props.checked}
              id="CardNursingDiagnosisUX-Checkbox-47"
              label={props.languageUX === "en" ? "Select all" : "เลือกทั้งหมด"}
              onChange={props.onChangeChecked}
              style={{padding: "10px"}}>
            </Checkbox>
            <div
              id="CardNursingDiagnosisUX-div-51">
              {props.buttonPrint}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardNursingDiagnosisUX

export const screenPropsDefault = {"roomDetail":"7C06 Ward  อายุรกรรม ห้อง Standard","searchLabel":"ค้นหา"}

/* Date Time : Mon Aug 18 2025 09:30:52 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardNursingDiagnosisUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNursingDiagnosisUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\",alignItems: \"center\",justifyContent: \"flex-end\", ...(props.isPHV && { display: \"none\" })}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 23,
      "name": "Table",
      "parent": 0,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": "props.columns_nursingDiagnosisList"
        },
        "data": {
          "type": "code",
          "value": "props.nursingDiagnosisList"
        },
        "getTrProps": {
          "type": "code",
          "value": ""
        },
        "headers": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNursingDiagnosisUX-Table-23"
        },
        "keys": {
          "type": "value",
          "value": ""
        },
        "minRows": {
          "type": "code",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"400px\", marginBottom: \"10px\"}"
        },
        "widths": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNursingDiagnosisUX-div-33"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\", ...(props.isPHV && { display: \"none\" })}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "Button",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือก Template",
          "valueEN": "Select Template"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardNursingDiagnosisUX-Button-43"
        },
        "onClick": {
          "type": "code",
          "value": "props.onTemplate"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"5px\"}"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "code",
          "value": "props.addButton"
        },
        "id": {
          "type": "value",
          "value": "CardNursingDiagnosisUX-div-45"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 33,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardNursingDiagnosisUX-div-46"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "Checkbox",
      "parent": 46,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checked"
        },
        "id": {
          "type": "value",
          "value": "CardNursingDiagnosisUX-Checkbox-47"
        },
        "label": {
          "type": "value",
          "value": "เลือกทั้งหมด",
          "valueEN": "Select all"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeChecked"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "code",
          "value": "props.nursingDiagnosisID"
        },
        "id": {
          "type": "value",
          "value": "CardNursingDiagnosisUX-div-49"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "code",
          "value": "props.searchButton"
        },
        "id": {
          "type": "value",
          "value": "CardNursingDiagnosisUX-div-50"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrint"
        },
        "id": {
          "type": "value",
          "value": "CardNursingDiagnosisUX-div-51"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\",alignItems: \"center\",justifyContent: \"flex-end\", ...(!props.isPHV && { display: \"none\" }) }"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrint"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Checkbox",
      "parent": 52,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.checked"
        },
        "label": {
          "type": "value",
          "value": "เลือกทั้งหมด",
          "valueEN": "Select all"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeChecked"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px\"}"
        }
      },
      "seq": 54,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 75,
  "isMounted": false,
  "memo": false,
  "name": "CardNursingDiagnosisUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "roomDetail": "7C06 Ward  อายุรกรรม ห้อง Standard",
    "searchLabel": "ค้นหา"
  },
  "width": 75
}

*********************************************************************************** */
